// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// firebase/messaging is deliberately NOT imported here. It pulls in
// @firebase/messaging + @firebase/installations (~114kB) and was landing in
// the entry bundle on every page load, even though push notifications are
// requested from exactly one hook, well after startup, and are unsupported
// on a large share of the browsers this app runs in. Imported on demand in
// getMessagingIfSupported below instead.

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Cloud Messaging isn't available on http://, in some in-app browsers, or on
// browsers without Push API support — resolve lazily and let callers no-op.
export const getMessagingIfSupported = async () => {
  const { isSupported, getMessaging } = await import(
    /* webpackChunkName: "firebase-messaging" */ 'firebase/messaging'
  );
  if (!(await isSupported())) return null;
  return getMessaging(app);
};

export default app;
